import styled from 'styled-components';
import { Label } from 'styles';

export const InputLabel = styled(Label)`
  display: flex;
  align-items: center;
  margin-bottom: 4px;

  @media ${({ theme }) => theme.device.mobile} {
  }
`;
